import { Divider } from "@mui/material";
import CheckboxTree, { CheckboxTreeStore } from "designSystem/components/checkbox/CheckboxTree";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import { GridColumn, SearchPlaceholder, SearchTextField, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { actionResource } from "./PushFromStyleService";
import { usePushFromStyleStore } from "./PushFromStyleStore";

export const PushSettingsForm: FunctionComponent = observer(() => {
	const store = usePushFromStyleStore();
	const {
		filteredAddDSLines,
		filteredUpdateDSLines,
		onChangePushSettings,
		onChangeSearchTextField,
		pushSettings,
		restoreAllDSLines,
		searchText,
		shouldDisplayUpdateSection,
		shouldDisplayAddSection,
	} = store;

	return (
		<GridColumn scroll spacing={4}>
			<Text res={actionResource("ConfigureRestoreSettings")} />
			<Text res={actionResource("RestoreSettings")} variant="h6" />
			<RadioGroup
				onChange={onChangePushSettings}
				options={pushSettings}
				value={restoreAllDSLines}
			/>
			<Divider />
			<SearchTextField
				fullWidth
				onChange={onChangeSearchTextField}
				placeholderRes="Search"
				value={searchText}
			/>
			{shouldDisplayUpdateSection && (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={[filteredUpdateDSLines.uniqueId]}
					displayCounts
					store={new CheckboxTreeStore([filteredUpdateDSLines])}
				/>
			)}
			{shouldDisplayAddSection && (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={[filteredAddDSLines.uniqueId]}
					displayCounts
					store={new CheckboxTreeStore([filteredAddDSLines])}
				/>
			)}
			{!shouldDisplayUpdateSection && !shouldDisplayAddSection && (
				<SearchPlaceholder 
					titleProps={{ res: "SEARCH_NO_RESULTS" }}
				/>
			)} 
		</GridColumn>
	);
});

export default PushSettingsForm;
